import request from "@/utils/request";
import download from "@/utils/download";

export const createFactoryDeliveryNote = (hqPackingListId: string) =>
  request({
    url: `/factory-delivery-notes/${hqPackingListId}`,
    method: "post",
  });

export const getFactoryDeliveryNote = (hqPackingListId: string) =>
  request({
    url: `/factory-delivery-notes/original-information/${hqPackingListId}`,
    method: "GET",
  });

export const downFactoryDeliveryNote = (hqPackingListId: string) =>
    download({
        responseType:"blob",
        url: `/factory-delivery-notes/${hqPackingListId}/download`,
        method:"GET"
    })

export const downloadReceiptNote = (hqPackingListId: string) =>
  download({
    responseType: "blob",
    url: `/receiptNote/${hqPackingListId}/download`,
    method: "GET",
  });

export const getFactoryDeliveryNoteOriginalInfo = (params: {
  hqPackingListId: string;
}) =>
  request({
    url: `/factory-delivery-notes/original-information`,
    method: "GET",
    params,
  });

export const getFactoryDeliveryNoteDetail = (hqPackingListId: string) =>
  request({
    url: `/factroy-delivery-notes/${hqPackingListId}/detail`,
    method: "GET",
  });
